/* NDA Chat API service */
import { http } from 'app/http';

const BASE = 'legals/nda-chat';

export interface StartChatRequest {
  formData?: any;
  templateId?: string;
  language?: string;
}

export interface StartChatResponse {
  sessionId?: string;
  chatId?: string;
  welcome?: string;
}

export interface ChatMessageRequest {
  sessionId?: string;
  chatId?: string;
  message: string;
  formData?: any;
  metadata?: { language?: string; variables?: Record<string, unknown> };
}

export interface ChatMessageResponse {
  answer?: string;
  reply?: string;
  extractedData?: Record<string, unknown>;
  chatId?: string;
  session?: {
    id: string;
    state?: string;
    variables?: Record<string, unknown>;
    nextExpected?: string;
    history?: Array<{ role: 'assistant' | 'user'; content: string }>;
  };
  updatedKeys?: string[];
}

export async function startChat(
  payload: StartChatRequest
): Promise<StartChatResponse> {
  const res = await http.post<StartChatResponse>(`${BASE}/start`, payload);
  return res.data;
}

export async function sendMessage(
  payload: ChatMessageRequest
): Promise<ChatMessageResponse> {
  const session = payload.sessionId ?? payload.chatId;
  const body: {
    sessionId: string;
    message: string;
    metadata?: { language?: string; variables?: Record<string, unknown> };
    formData?: any;
  } = {
    sessionId: String(session ?? ''),
    message: payload.message,
    metadata: payload.metadata,
    formData: payload.formData
  };
  const res = await http.post<ChatMessageResponse>(`${BASE}/ask`, body);
  return res.data;
}
